import React, { useMemo, useContext, useState, useEffect } from 'react';

import Close from '../../Reutilizaveis/CloseButton';

import { ContainerModalItems, ErrorMessage, Title, Modal } from './styles';

import CardParcelasSelecionadas from '../GerarBoleto/ParcelasSelecionadas/CardParcelasSelecionadas';
import { ButtonPrimary, Spinner } from '../../StyledComponent';
import formatCurrent from '../../../Utils/formatCurrent';

import copyTextToClipboard from '../../../Utils/copyTextToClipboard';
import { ReactComponent as ErrorIcon } from '../../../assets/novosicones/ErrorIcon.svg';
import useWindowDimension from '../../../hooks/WindowDimension';
import { ContextoFinanceiro } from '../../../services/financeiro';
import { getPadraoCobranca } from '../../../Utils/PixFunctions';
import DiscountTextAdvancedPayment from '../../DiscountTextAdvancedPayment';
import { useHistory } from 'react-router-dom';

const ModalGerarPix = ({
  setGerarPix,
  tema,
  contratoSelecionado,
  parcelasAPagarFunction,
}) => {
  const [error, setError] = useState(false);
  const [isPixCodeGenerated, setIsPixCodeGenerated] = useState(false);
  const [pixCode, setPixCode] = useState('');
  const [isCodeCopied, setIsCodeCopied] = useState('');
  const [qrCodeImg, setQrCodeImg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();
  const dimensions = useWindowDimension();
  const errorMsg = `Ocorreu um erro temporário, por favor tente mais tarde ou escolha
  outra forma de pagamento.`;

  const { parcelasPix, gerarPix } = useContext(ContextoFinanceiro);

  const totalJuros =
    parcelasPix[0]?.parcela?.vlJuros + parcelasPix[0]?.parcela?.vlJurosAtraso;

  const totalMulta = parcelasPix[0]?.parcela?.vlMulta;

  const totalAcrescimos =
    parcelasPix[0]?.parcela?.vlJuros +
    parcelasPix[0]?.parcela?.vlJurosAtraso +
    totalMulta;

  const copyCodeButtonText = useMemo(() => {
    let buttonText = 'COPIAR CÓDIGO PIX';

    if (isCodeCopied) {
      buttonText = 'CÓDIGO PIX COPIADO';
    }

    return buttonText;
  }, [isCodeCopied]);

  const value = parcelasPix[0]?.parcela?.valorReajustado;

  const temPix = parcelasPix[0]?.parcela?.temPix;

  async function handleGeneratePixCode() {
    try {
      setIsLoading(true);

      const {
        idVenda,
        idReceber,
        empresa,
        obra,
        numeroVenda,
        numeroParcela,
        tipoParcela,
        numeroParcelaGeral,
      } = parcelasPix[0]?.parcela;

      const padraoCobranca = getPadraoCobranca(
        parcelasPix,
        contratoSelecionado
      );

      const { qrCode, pixCopiaECola } = await gerarPix({
        padraoCobranca: Number(padraoCobranca),
        parcela: {
          idVenda,
          idReceber,
          empresa,
          obra,
          numeroVenda,
          numeroParcela,
          tipoParcela,
          numeroParcelaGeral,
        },
      });

      setIsPixCodeGenerated(true);

      setQrCodeImg(qrCode);
      setPixCode(pixCopiaECola);
    } catch (error) {
      setError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  function handleClickCopyToClipboard() {
    (async function () {
      await copyTextToClipboard(pixCode);
      setIsCodeCopied(true);
      setTimeout(() => {
        setIsCodeCopied(false);
      }, 4000);
    })();
  }

  function handleValueClassName(value) {
    if (value > 0) {
      return 'hasValue';
    }

    return '';
  }

  async function handleCloseModal() {
    setGerarPix(false);

    if (isPixCodeGenerated) {
      await parcelasAPagarFunction();
    }
  }

  useEffect(() => {
    (async function () {
      if (temPix) {
        await handleGeneratePixCode();
      }
    })();
    history.replace('/financeiro/#modal-pix');

    return () => {
      history.replace('/financeiro');
    };
  }, []);

  return (
    <Modal id='modalGerarPix'>
      <ContainerModalItems color={tema.primaryColor}>
        <div className='header' id='headerModalGerarPix'>
          <Title color={tema.primaryColor}>
            <h1>Pagamento no Pix</h1>
            <Close
              onClick={handleCloseModal}
              corBackground={'#ffffff'}
              borderColor={'#B91C1C'}
              tamanho={'30px'}
              marginRight={0}
              id={'fecharModalPagamentoPix'}
              disabled={isLoading}
            />
          </Title>
        </div>
        {error && dimensions.winWidth > 1000 && (
          <ErrorMessage id='msgErroDesktop'>
            <ErrorIcon />
            {errorMsg}
          </ErrorMessage>
        )}
        <div className='container-body'>
          <div className='container-main'>
            <div className='pix-value-container'>
              <div className='parcel'>
                <div>
                  <div>
                    <span className='parcels-selected-text'>
                      Parcelas selecionadas:
                    </span>

                    <span className='parcels-quantity-text'>
                      01 parcela(s) em aberto
                    </span>
                    <CardParcelasSelecionadas
                      parcela={parcelasPix[0]}
                      tema={tema?.primaryColor}
                    />
                  </div>
                  <p>
                    *O pix é gerado com a soma e desconto(s) aplicados às
                    parcelas selecionadas.
                  </p>
                </div>
                <DiscountTextAdvancedPayment parcelas={parcelasPix} />
              </div>

              <div className='values-container'>
                <div className='values'>
                  <span className={handleValueClassName(totalJuros)}>
                    Total de juros:{' '}
                    <span className='value' id={'totalJurosPix'}>
                      {formatCurrent(totalJuros)}
                    </span>
                  </span>
                  <span className={handleValueClassName(totalMulta)}>
                    Total de multa:{' '}
                    <span className='value' id={'totalMultaPix'}>
                      {formatCurrent(totalMulta)}
                    </span>
                  </span>
                  <span className={handleValueClassName(totalAcrescimos)}>
                    Total de acréscimos:{' '}
                    <span className='value' id={'totalAcrescimosPix'}>
                      {formatCurrent(totalAcrescimos)}
                    </span>
                  </span>
                </div>
                <div className='total-value'>
                  <span className='label'>Valor total:</span>
                  <span className='value' id={'totalPix'}>
                    {formatCurrent(value)}
                  </span>
                </div>
              </div>
            </div>

            {error && dimensions.winWidth < 1000 && (
              <ErrorMessage id='msgErroMobile'>
                <ErrorIcon />
                {errorMsg}
              </ErrorMessage>
            )}

            <div className='pix-code-container'>
              {!isPixCodeGenerated && (
                <div className='generate-pix-code' id='modalGerarCodigoPix'>
                  <h2>Atenção:</h2>
                  <p>
                    Ao clicar em gerar código pix, você confirma que o pagamento
                    será feito até as 23:59h de hoje.
                    <br />
                    <br />
                    Após esse horário o código vai perder a validade.
                    <br />
                    <br />
                    Durante este tempo você não poderá selecionar outra forma de
                    pagamento.
                  </p>

                  <ButtonPrimary
                    tema={tema}
                    fullWidth
                    onClick={handleGeneratePixCode}
                    id='botaoGerarCodigoPix'
                    disabled={isLoading}
                  >
                    {!isLoading && 'GERAR CÓDIGO PIX'}
                    {isLoading && (
                      <>
                        CARREGANDO...
                        <Spinner />
                      </>
                    )}
                  </ButtonPrimary>
                </div>
              )}

              <div
                className={`code-generated  ${
                  !isPixCodeGenerated ? 'isHidden' : ''
                }`}
              >
                <h2>QR code:</h2>
                <img
                  alt='imagem qr code'
                  src={'data:image/png;base64,' + qrCodeImg}
                />
                <p>
                  Copie o código Pix abaixo e cole em seu app de pagamento para
                  finalizar o pagamento.
                </p>

                <input
                  type='text'
                  readOnly
                  value={pixCode}
                  className='input-code'
                  id='codigoPixGerado'
                />
                <ButtonPrimary
                  tema={tema}
                  fullWidth
                  onClick={handleClickCopyToClipboard}
                  disabled={isCodeCopied}
                  id='botaoCopiarCodigo'
                >
                  {copyCodeButtonText}
                </ButtonPrimary>
              </div>
            </div>
          </div>

          <div className='important-infos-container'>
            <span className='title'>Informação importante:</span>
            <div>
              <span>
                Realize o pagamento até as <b>23:59h</b> de hoje.
              </span>
            </div>
          </div>
        </div>
      </ContainerModalItems>
    </Modal>
  );
};

export default ModalGerarPix;
